import bridge from '../core';

const apiName = 'share';

function fallback() {
    // console.log('非app');
}

function back(params) {
    return {
        api: JSON.stringify(params),
        fallback
    };
}

bridge.register(apiName, back);
